import { render } from "./App.vue?vue&type=template&id=2ae73881"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2ae73881&lang=css"

import exportComponent from "/home/stangerjm/lord-baldwin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__